import { isTokenUsable } from '~/helpers/axiosAuth'

// ページ遷移時に認証トークンを取り直して store に入れる。
// 取得は plugins/axios.js が注入する $authToken(1 回再試行・単一飛行・クールダウン)を使い、
// 結果に応じて accessTokenStatus を残す(requiredAuth / setCurrentUser が参照する)。
//   ok           : トークンを更新
//   session-lost : ログインしていない / セッション無効。
//                  ただしブラウザのサイトデータが消えるなどで Amplify のセッションだけが無くなった場合でも、
//                  store(メモリ)に期限内の ID トークンが残っていればそれを保ち、ログアウト扱いにしない
//                  (API 側も同じトークンで送る。plugins/axios.js を参照)。それ以外は accessToken=false(requiredAuth がログイン画面へ)
//   unavailable  : 一時的に取れない。既存の accessToken はそのまま残し、サインアウトはしない
export default async ({ store, app }) => {
  const result = await app.$authToken.resolve()
  app.$authToken.report(result)
  store.commit('setAccessTokenStatus', result.status)
  if (result.status === 'ok') {
    store.commit('setAccessToken', result.token)
    return
  }
  if (result.status === 'session-lost') {
    const fallback = isTokenUsable(store.state.accessToken)
    if (store.state.accessToken) {
      // 直前までトークンがあったのにセッションが無くなった。ページ遷移で発覚した場合も Sentry に残す
      // (API 呼び出しの前に accessToken を消してしまうと onRequest 側では記録されないため)
      app.$authToken.reportLost(result, { fallback })
    }
    if (fallback) {
      return
    }
    store.commit('setAccessToken', false)
  }
}
